<template>
  <div id="dialog" @click.self="closeDialog">
    <div class="border">
      <!-- <div @click.stop="closeDialog" class="closeImg">X</div> -->
      <div class="video-wrap">
           <video
                muted
                x5-playsinline="" playsinline="" webkit-playsinline=""
                data-object-fit="true"
                class="aboutUs-video"
                :src="videoSrc"
                controls
                autoplay
                loop
              ></video>
      </div>
      <img @click.stop="closeDialog"  class="video-wrap-close" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAAIVBMVEVHcEz///////////////////////////////////////+PBM77AAAACnRSTlMAf+MhX6qQQMcQq7YEWgAAAIBJREFUKM9jYBjEYKIDhC4zgAtlLQRTLKsU4EJSqwRAlNeqBrgQ46qFYEWLEBohyrxWKSOZD1KGqgisDFURSNlSNEUgZWiKGBhYMRQBrYO4DQGA1q1aiK5IWQpVGchNjKjKwG5CUQZxOIqyKoibkJVFQdzEiBReRs0QWkiAYWgBAMHyJ4XCGjWxAAAAAElFTkSuQmCC"/>
    </div>
  </div>
</template>
 
<script>
  export default {
    name: "Dialog",
    data(){
      return {
          videoSrc:''
      }
    },
    methods:{
      closeDialog(){
         //给父组件传参
         this.$emit('closeDialog',false)
      },
      playVideo(videoSrc) {
          console.log('videoSrc', videoSrc)
          this.videoSrc = videoSrc
      }
    }
  }
</script>
 
<style scoped>
  #dialog{
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.3);
    width: 100%;
    height: 100%;
  }
  .message{
    text-align: center;
    position: absolute;
    top: 50%;
  }
  .closeImg{
    width: 20px;
    height: 20px;
    float: right;
    margin-right: 5px;
    margin-top: 5px;
    cursor: pointer;
    /* background-image: url(../../assets/close.png); */
    background-size: cover;
    background-repeat: no-repeat;
  }
  .border{
    text-align: center;
    background-color: white;
    border-radius: 20px;
    width: 960px;
    height:540px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .video-wrap{
      width: 100%;
      height: 100%;
  }
  .aboutUs-video {
  object-fit: fill;
  width: 100%;
  height: 100%;
  border-radius: 16px;
}
.video-wrap-close{
    position: absolute;
     left: 50%;
     transform: translate(-50%,-50%);
    bottom: -60px;
}
@media screen and (min-width: 0) and (max-width: 1200px) {
   .border{
    width:480px;
    height:270px;
    /* transform: scale(0.5); */
  }
}
@media screen and (min-width: 0) and (max-width: 480px) {
   .border{
    width:320px;
    height:180px;
    /* transform: scale(0.5); */
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog.vue